var sliderTestimonials = tns({
  container: '.slider',
  items: 1,
  slideBy: 'page',
  controls: false,
  navContainer: '.slider__nav',
  navItem: '.slider__nav__item',
});

// Animation

const sectionAnimation = () => {
  const sections = document.querySelectorAll('[data-animate]');  
  
  sections.forEach(section => {
    const halfWindow = window.innerHeight * 0.6;
    const isSectionVisible = (section.getBoundingClientRect().top - halfWindow) < 0;

    if(isSectionVisible) {
      section.setAttribute("data-animate", "true");
    }
  });  
}

window.addEventListener('scroll', sectionAnimation);
